import React from 'react'
import { Alert } from '@chakra-ui/react'

export default (props) => {
  return (
    <Alert.Root status={props.status} variant='subtle' colorPalette={props.colorPalette}>
      {props.withIcon !== false ? <Alert.Indicator /> : null}
      <Alert.Content>
        {props.title && <Alert.Title>{props.title}</Alert.Title>}
        <Alert.Description>{props.children}</Alert.Description>
      </Alert.Content>
    </Alert.Root>
  )
}
